import { render, staticRenderFns } from "./Blocking.vue?vue&type=template&id=4c187b64&"
import script from "./Blocking.vue?vue&type=script&lang=js&"
export * from "./Blocking.vue?vue&type=script&lang=js&"
import style0 from "./Blocking.vue?vue&type=style&index=0&id=4c187b64&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports